<template >
    <div style="">
        <div  >

            <div style="top:-156px;position:fixed;width:100%;">
                <div style="z-index:0;position:relative;width:100%;height:calc(100vh + 200px);margin-left:0;background: rgb(154,255,186);background: linear-gradient(40deg, rgba(164, 65, 248, 0.72) 0%, rgb(47, 218, 158) 100%);">
                    <video id="video_flare2"  muted="" loop autoplay class="fullscreen-bg__video" style="pointer-events: none;z-index: -1;">
                        <source :src="require('../assets/white_flare.webm')" type="video/webm">

                    </video>
                    <v-img v-if="$vuetify.breakpoint.mdAndUp" :src="require('../assets/soh_event.jpg')" style="width:100%;height:100%;opacity:0.6;">

                    </v-img>
                    <v-img v-else :src="require('../assets/soh_event_small2.jpg')" style="width:100%;height:100%;opacity:0.6;">

                    </v-img>

                </div>




            </div>
            <v-row
                    align="center"
                    justify="center"

                    class="mx-auto"
                    style="height:80vh;top:0;z-index: 0;position: fixed;width:100%;"

            >


                <v-col align="center"  style="max-width:600px;background: rgba(129, 134, 169, 0.34); border-radius: 20px;padding:20px;" >
                    <h1 class="display-3 font-weight-bold mb-3 text--uppercase" >/inv hihat</h1>

                    <h3 class="font-weight-light" style="margin-top:40px;"> Planerar du ett event? Bjud in oss!</h3>

                    <span>

                </span>


                </v-col>

            </v-row>














            <v-row align="center"  justify="center" class="px-12" style="background:#e7e7e7;margin-top:800px;position: relative;;z-index: 1;padding-bottom:80px;">


                <v-col  cols="12" >
                    <v-subheader :style="{'margin-top':$vuetify.breakpoint.mdAndUp? '':'40px'}" ><v-spacer></v-spacer><span>Digitala events, så som välgörenhetsstreams och tävlingar i e-sport, tycker vi är kul!<br> Om du har stora planer men känner att det tryter på den digitala biten, <a href="/about">tveka inte att höra av dig</a>! </span><v-spacer></v-spacer></v-subheader>
                    <v-subheader :style="{'margin-top':$vuetify.breakpoint.mdAndUp? '':'40px'}" ><v-spacer></v-spacer><span>Tidigare samarbeten: </span><v-spacer></v-spacer></v-subheader>


                </v-col>
                <v-col :cols="$vuetify.breakpoint.mdAndUp? '6':'12'">
                    <v-card
                            class="mx-auto"
                            max-width="344"
                            outlined
                    >
                        <v-img height="80" width="80" style="position: absolute;top:0;right:10px;" :src="require('../assets/bcf.png')">

                        </v-img>
                        <v-card-subtitle class="pb-0">
                            Stream of Hope
                        </v-card-subtitle>
                        <v-card-title class="pt-0">
                            Barncancerfonden
                        </v-card-title>
                        <v-card-text>
                            En välgörenhetsstream i kampen mot barncancer
                            <div class="overline mb-4">15/2 - 2020</div>

                        </v-card-text>


                    </v-card>

                </v-col>
                <v-col :cols="$vuetify.breakpoint.mdAndUp? '6':'12'">
                    <v-card
                            class="mx-auto"
                            max-width="344"
                            outlined
                    >
                        <v-img height="80" width="80" style="position: absolute;top:0;right:10px;" :src="require('../assets/givinggamers/Giving-Gamers-Black.png')">

                        </v-img>
                        <v-card-subtitle class="pb-0">
                            Giving Gamers
                        </v-card-subtitle>
                        <v-card-title class="pt-0">
                            Giving People
                        </v-card-title>
                        <v-card-text>
                            En välgörenhetsstream för att hjälpa och göra skillnad för utsatta barnfamiljer
                            <div class="overline mb-4">6/6 - 2020</div>

                        </v-card-text>


                    </v-card>

                </v-col>
            </v-row>

















        </div>


    </div>
</template>

<script>
    export default {
        name: 'Events',
        components: {

        },
        data(){
            return {

            }

        },
        computed:{

            minHeight () {
                const height = this.$vuetify.breakpoint.mdAndUp ? '100vh' : '50vh'

                return `calc(${height} - ${this.$vuetify.application.top}px)`
            }
        },
        methods:{
            letsgo:function(){
                this.$store.state.APP.SHOW_LOGIN=true;
            },



        },
        mounted:function(){
            document.title="Hihat";


        }

    }
</script>

<style scoped>
    .lift_me_up> * img{
        top:-200px;
    }

    @keyframes spin {
        from {
            transform:rotate(0deg);
        }
        to {
            transform:rotate(360deg);
        }
    }

    .spin_da_guthen{
        animation-name: spin;
        animation-duration: 1000ms;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
        /* transform: rotate(3deg); */
        /* transform: rotate(0.3rad);/ */
        /* transform: rotate(3grad); */
        /* transform: rotate(.03turn);  */
    }

    .theme--dark.v-data-table tbody tr:hover{
        background: rgba(255,255,255,0.1) !important;
    }
</style>
